import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import Acceptance from "./../../applicant/routes/dashboard/acceptance";
import ApplicantForm from "./../../components/ApplicantForm/index";

class ApplicantMenuList extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) { }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) { }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function (fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) { }

    return null;
  }

  render() {
    const { user, } = this.props;


    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="nav-header">
            <IntlMessages id="sidebar.menu" />
          </li>

          <li className="menu no-arrow">
            <NavLink to="/applicant/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.dashboard" />
              </span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/applicant/biodata">
              <i className="zmdi zmdi-assignment-account zmdi-hc-fw" />
              <span className="nav-text">Bio-Data</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/applicant/hostel">
              <i className="zmdi zmdi-assignment-account zmdi-hc-fw" />
              <span className="nav-text">Hostel</span>
            </NavLink>
          </li>
          {user.EntryModeId === 1 && (
            <li className="menu no-arrow">
              <NavLink to="/applicant/screeningfees">
                <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
                <span className="nav-text">Screening Fees</span>
              </NavLink>
            </li>
          )}

          {/* <li className="menu no-arrow">
            <NavLink to="/applicant/documents">
              <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
              <span className="nav-text">Upload Documents</span>
            </NavLink>
          </li> */}

          <li className="menu no-arrow">
            <NavLink to="/applicant/probationalResult">
              <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
              <span className="nav-text">Probational Result</span>
            </NavLink>
          </li>

          {/* {(
  (user.EntryModeId === 1 && (user.AdmissionLevel === 4 || user.AdmissionLevel === 5)) || 
  ((user.EntryModeId === 1 || user.EntryModeId === 2 || user.EntryModeId === 3) && user.RegComplete === true) // 👈 add parentheses
) && (
  <li className="menu no-arrow">
    <NavLink to="/applicant/results">
      <i className="zmdi zmdi-file-text zmdi-hc-fw" />
      <span className="nav-text">Result</span>
    </NavLink>
  </li>
)} */}

          {/* {user?.AdmModeId !== 2 &&
            <li className="menu no-arrow">
              <NavLink to="/applicant/utmeresult">
                <i className="zmdi zmdi-file-text zmdi-hc-fw" />
                <span className="nav-text">Utme Result</span>
              </NavLink>
            </li>
          }

          <li className="menu no-arrow">
            <NavLink to="/applicant/olevel">
              <i className="zmdi zmdi-file zmdi-hc-fw" />
              <span className="nav-text">O'Level</span>
            </NavLink>
          </li>

          {user?.AdmModeId === 2 &&
            <li className="menu no-arrow">
              <NavLink className="prepend-icon" to="/applicant/nddetails">
                <i className="zmdi zmdi-assignment-account zmdi-hc-fw" />
                <span className="nav-text">ND Details</span>
              </NavLink>
            </li>
          }
          {user?.AdmModeId === 2 &&
            <li className="menu no-arrow">
              <NavLink to="/applicant/documents">
                <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
                <span className="nav-text">Upload Documents</span>
              </NavLink>
            </li>
          } 

          {/* {user.RegComplete ? (
            <li className="menu"> */}
          {/* <Button className="void">
                <i className="zmdi zmdi zmdi-folder-outline zmdi-hc-fw mdc-text-amber" />
                <span className="nav-text">Documents</span>
              </Button> */}
          {/* <ul className="sub-menu"> */}
          {/* <li>
                  <NavLink to="/applicant/documents">
                    <i style={{ color: "#FFd07F" }} className="zmdi zmdi-file-plus zmdi-hc-fw" />
                    <span className="nav-text">Application Documents</span>
                  </NavLink>
                </li> */}
          {/* <li>
                  <NavLink to="/applicant/admissiondocs">
                    <i style={{ color: "#FFa07F" }} className="zmdi zmdi-file-text zmdi-hc-fw" />
                    <span className="nav-text">Admission Documents</span>
                  </NavLink>
                </li> */}
          {/* </ul> */}
          {/* </li>
          ) : // : ( */}
          {/* //   <li className="menu no-arrow">
          //     <NavLink to="/applicant/documents">
          //       <i className="zmdi zmdi-file-plus zmdi-hc-fw" />
          //       <span className="nav-text">Upload Documents</span>
          //     </NavLink>
          //   </li>
          // ) */}
          {/* null} */}

          <li className="menu no-arrow">
            <NavLink to="/applicant/paymenthistory">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">Payment History</span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            <NavLink to="/applicant/changepassword">
              <i className="zmdi zmdi-key zmdi-hc-fw" />
              <span className="nav-text">Change Password</span>
            </NavLink>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(ApplicantMenuList);
